import { createStyles, makeStyles } from '@material-ui/styles';

const style = () =>
  createStyles({
    root: {
      fontWeight: 700,
      padding: '50px',
      margin: 'auto',
      verticalAlign: 'center'
    }
  });
const useStyle = makeStyles(style);
export default useStyle;
